import * as actionType from '../actionTypes';
const initialState = {
    labels:[],
    defaultstyle: {}
}
// label reducer to store labels data in redux state
const labelReducer = (state =initialState, action) =>{
    switch( action.type ){
        case actionType.LOAD_LABELS:
            return {
                ...state,
                labels: action.payload
            }
        case actionType.LOAD_DEFAULT_STYLE:
            return {
                ...state,
                defaultstyle: action.payload
            }
        default:
            return state    
    };
}
export default labelReducer;